import { ComingSoon } from '../components/ui';

export default function ComingSoonPage() {
  return (
    <ComingSoon />
  );
}
